import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.7_@playwright+test@1.61.1_react-dom@19.2.8_react@19.2.8__react@19.2.8_sass@1.102.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/microservice/node_modules/.pnpm/next@15.5.18_@babel+core@7.29.7_@playwright+test@1.61.1_react-dom@19.2.8_react@19.2.8__react@19.2.8_sass@1.102.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/client/index.ts");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/components/shared/error-boundary/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterBlock"] */ "/microservice/src/app/components/shared/footer/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBlock"] */ "/microservice/src/app/components/shared/header/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlockBoundary"] */ "/microservice/src/app/features/landing/BlockBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalloutBanner"] */ "/microservice/src/app/features/landing/blocks/CalloutBanner/CalloutBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedOffer"] */ "/microservice/src/app/features/landing/blocks/FeaturedOffer/FeaturedOffer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InviteHero"] */ "/microservice/src/app/features/landing/blocks/InviteHero/InviteHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KitOptions"] */ "/microservice/src/app/features/landing/blocks/KitOptions/KitOptions.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/features/landing/blocks/SocialProof/SocialProof.module.scss");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/features/landing/blocks/Testimonials/Testimonials.module.scss");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/features/landing/blocks/HowItWorksSteps/HowItWorksSteps.module.scss");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/features/landing/LandingBlocksRenderer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["VipLandingAnalytics"] */ "/microservice/src/app/features/landing/VipLandingAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlockBoundary"] */ "/microservice/src/app/features/special-offers/BlockBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedCardContent"] */ "/microservice/src/app/features/special-offers/blocks/FeaturedOffer/FeaturedCardContent.tsx");
;
import(/* webpackMode: "eager" */ "/microservice/src/app/features/special-offers/blocks/FeaturedOffer/FeaturedOffers.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FindPartyAndConsultantClient"] */ "/microservice/src/app/features/special-offers/blocks/FindPartyAndConsultant/FindPartyAndConsultantClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferCardGalleryView"] */ "/microservice/src/app/features/special-offers/blocks/OfferCard/OfferCardGalleryView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferHeroView"] */ "/microservice/src/app/features/special-offers/blocks/OfferHero/OfferHeroView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToPrevious"] */ "/microservice/src/app/features/special-offers/components/back-to-previous/BackToPrevious.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToPreviousView"] */ "/microservice/src/app/features/special-offers/components/back-to-previous/BackToPreviousView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalloutBanner"] */ "/microservice/src/composites/landing/CalloutBanner/CalloutBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CheckList"] */ "/microservice/src/composites/landing/CheckList/CheckList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/microservice/src/composites/landing/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageCollage"] */ "/microservice/src/composites/landing/ImageCollage/ImageCollage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MinimalFooter"] */ "/microservice/src/composites/landing/MinimalFooter/MinimalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MinimalHeader"] */ "/microservice/src/composites/landing/MinimalHeader/MinimalHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfferCard"] */ "/microservice/src/composites/landing/OfferCard/OfferCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Rating"] */ "/microservice/src/composites/landing/Rating/Rating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResponsiveImage"] */ "/microservice/src/composites/landing/ResponsiveImage/ResponsiveImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionHeading"] */ "/microservice/src/composites/landing/SectionHeading/SectionHeading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Steps"] */ "/microservice/src/composites/landing/Steps/Steps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Testimonial"] */ "/microservice/src/composites/landing/Testimonial/Testimonial.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoCallout"] */ "/microservice/src/composites/landing/VideoCallout/VideoCallout.tsx");
